export default {
	lang: 'ko',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav0": '계정 보안',
		"nav1": '내 클라우드 디스크',
		"nav2": '로그아웃',
		"nav3": '로그인/가입',
		"nav4": '휴대폰의 통화 및 오디오 콘텐츠를 녹음하고 텍스트로 변환할 수 있습니다. 사용하려면 VTransBUDS 시리즈 헤드폰을 연결해야 합니다.',
		"nav5": '코드를 스캔하여 다운로드하세요',
		"nav6": '중요한 소통, 효율적인 백트래킹',
		"speaker_not_null": '스피커가 비어 있어 편집할 수 없습니다!',
		"speaker": '스피커',
		"copy_success": '복사 성공',
	},
	login: {
		"login1": '비밀번호 로그인',
		"login2": 'SMS 로그인',
		"loginTab3": '이메일 로그인',
		"login3": '이메일',
		"login4": '로그인 비밀번호',
		"login5": '휴대전화 번호',
		"login6": '선택해 주세요',
		"login7": '휴대전화 인증번호',
		"login8": '로그인',
		"login9": '비밀번호를 잊으셨나요?',
		"login10": '가입',
		"login11": '로그인 시 동의하는 것으로 간주됩니다',
		"login12": '서비스 계약',
		"login13": '개인정보 보호 계약',
		"login14": '받기',
		"login15": '중국',
		"login16": '계정을 입력해 주세요',
		"login17": '계정을 입력해 주세요 비밀번호',
		"login18": '로그인 성공!',
		"login19": '인증 코드를 입력하세요!',
		"login20": '전송 완료!',
		"login21": '그리고',
		"login22": '녹음기 클라우드 디스크',
		"login23": '내 글',
		"login24": '내 대화',
		"login25": '계정 보안',
		"login26": '로그아웃',
		"login27": '이메일 비밀번호 찾기',
		"login28": '이메일',
		"login29": '이메일 인증 코드',
		"login30": '로그인 비밀번호 설정(6~16자)',
		"login31": '로그인 비밀번호를 다시 입력하세요',
		"login32": '제출',
		"login33": '다음으로 돌아가기 로그인',
		"login34": '변경이 완료되었습니다!',
	},
	register: {
		"register1": '휴대전화 번호',
		"register2": '휴대전화 번호를 입력하세요',
		"register3": '선택하세요',
		"register4": '휴대전화 인증번호',
		"register5": '비밀번호 설정',
		"register6": '인증번호를 입력하세요',
		"register7": '6-16자',
		"register8": '비밀번호 확인',
		"register9": '이메일',
		"register10": '이메일을 입력하세요',
		"register11": '이메일 인증번호',
		"register12": '인증번호를 입력하세요',
		"register13": '읽고 동의합니다',
		"register14": '동의 내용을 읽고 확인하세요',
		"register15": '휴대전화 번호 형식이 잘못되었습니다 / 휴대전화 번호가 등록되었습니다',
		"register16": `휴대전화 인증번호는 잘못됨`,
		"register17": '이메일을 입력하세요 / 이메일 형식 오류',
		"register18": '이메일 형식 오류',
		"register19": '이메일 인증 코드 오류',
		"register20": '비밀번호를 6~16자로 설정하세요',
		"register21": '비밀번호 형식 오류',
		"register22": '두 비밀번호가 일치하지 않습니다. 다시 입력하세요',
		"register23": '비밀번호를 입력하세요',
		"register24": '등록 완료!',
		"register25": '인증 코드 오류',
	},
	recorder: {
		"recorder1": '내 클라우드 디스크',
		"recorder2": '클라우드 공간 용량',
		"recorder3": '최근 파일',
		"recorder331": '휴지통',
		"recorder332": '모두 삭제',
		"recorder4": '이름',
		"recorder5": '오디오 재생 시간',
		"recorder6": '파일 크기',
		"recorder7": '생성 시간',
		"recorder8": '작업',
		"recorder9": '클라우드 공간 설명',
		"recorder10": '오디오',
		"recorder11": 'OCR 파일',
		"recorder12": '1. 클라우드 공간은 어떤 용도로 사용되나요?',
		"recorder13": '레코더에서 녹음한 후, 오디오와 필사된 파일을 클라우드 공간에 업로드할 수 있습니다. 레코더가 없어도 클라우드 공간에 접속하여 오디오를 볼 수 있습니다. ',
		"recorder14": '2. 클라우드 공간에 업로드하는 방법',
		"recorder15": '레코더에서 [내 파일]을 입력하고, 대상 파일을 선택한 후 길게 눌러 옵션을 표시한 후, "업로드"를 클릭하여 파일을 클라우드 공간에 업로드합니다. ',
		"recorder16": '3. 클라우드 공간 파일을 보거나 관리하는 방법',
		"recorder17": '베이보 공식 웹사이트에 로그인하여 "내 레코더 클라우드 디스크"를 선택하면 업로드된 레코더 파일을 볼 수 있습니다. 대상 파일을 선택하여 다운로드, 삭제 및 기타 작업을 수행할 수 있습니다. 클라우드 파일을 삭제하여 클라우드 저장소를 정리할 수 있습니다!',
		"recorder18": '녹음되지 않음',
		"recorder19": '요약 보기',
		"recorder20": '발언자',
		"recorder21": '발언자 이름 수정',
		"recorder22": '확인',
		"recorder23": '다운로드',
		"recorder24": '콘텐츠 다운로드:',
		"recorder25": '다운로드 설정:',
		"recorder26": '발언자 표시',
		"recorder27": '취소',
		"recorder28": '링크 공유',
		"recorder29": '링크를 받은 사람은 누구나 액세스할 수 있습니다. 읽기만 가능합니다. 링크는 7일 동안 유효합니다.',
		"recorder30": '링크 복사',
		"recorder31": '스캔하여 빠르게 보기',
		"recorder32": '스마트 정리',
		"recorder33": '화자 구분',
		"recorder34": '화자 역할에 따라 필사된 텍스트를 지능적으로 구분',
		"recorder35": '지능형 음성 언어 정규화',
		"recorder36": '조동사, 반복되는 단어, 멈춤 단어 자동 필터링',
		"recorder37": '인간이 아닌 음성 필터링',
		"recorder38": '재생 중 인간 음성 및 잡음 없이 오디오를 자동으로 건너뜁니다',
		"recorder39": '선택하세요',
		"recorder40": '문서',
		"recorder41": '오디오',
		"recorder42": '문서+오디오',
		"recorder43":'프롬프트',
		"recorder44":'이 작업은 파일을 삭제합니다. 계속하시겠습니까?',
		"recorder441":'이 작업은 모든 파일을 삭제합니다. 계속하시겠습니까?',
		"recorder45":'확인',
		"recorder46":'취소',
		"recorder47":'삭제되었습니다!',
		"recorder48":'삭제 취소됨',
		"recorder49":'아직 표시하지 않음',
		"recorder50":'저장 중...',
		"recorder51":'휴지통',
	},
	personal: {
		"personal1": '계정 설정',
		"personal2": '개인 정보',
		"personal3": '아바타',
		"personal4": '파일 업로드',
		"personal5": 'JPG, JPEG, GIF, PNG 스타일 지원, 2M 이내 사진 지원',
		"personal6": '닉네임',
		"personal7": '닉네임을 입력해 주세요',
		"personal8": '성별',
		"personal9": 'Mr.',
		"personal10": 'Ms.',
		"personal11": '비공개',
		"personal12": '생일',
		"personal13": '생일을 선택해 주세요',
		"personal14": '직업',
		"personal15": '직업을 선택해 주세요',
		"personal16": '직업을 입력해 주세요 (선택 사항)',
		"personal17": '국가',
		"personal18": '국가를 선택하세요',
		"personal19": '저장',
		"personal20": '개인 정보',
		"personal21": '계정 보안',
		"personal22": '2M 이내의 사진만 지원',
		"personal23": '업로드 완료!',
		"personal24": '변경 완료!',
		"personal25": '계정 보안',
		"personal26": '로그인 비밀번호',
		"personal27": '변경',
		"personal28": '이메일',
		"personal29": '변경',
		"personal30": '계정 취소',
		"personal32": '계정을 취소하시겠습니까?',
		"personal33": '취소 후 계정의 모든 콘텐츠는 허가되었으니, 주의해서 운영하시기 바랍니다. ',
		"personal34": '취소',
		"personal35": '확인',
		"personal36": '인증',
		"personal37": '본인 확인 절차를 위해 이메일 인증 코드를 입력하여 본인 확인을 완료해 주세요.',
		"personal38": '이메일',
		"personal39": '인증 코드',
		"personal40": '인증 코드를 입력해 주세요.',
		"personal41": '다음',
		"personal42": '새 이메일 설정',
		"personal43": '이메일',
		"personal44": '새 이메일을 입력해 주세요.',
		"personal45": '인증 코드',
		"personal46": '인증 코드를 입력해 주세요.',
		"personal47": '확인',
		"personal48": '새 로그인 비밀번호 설정',
		"personal49": '새 로그인 비밀번호',
		"personal50": '새 비밀번호를 입력하세요',
		"personal51": '새 비밀번호 확인',
		"personal52": '새 비밀번호를 다시 입력하세요',
		"personal53": '확인',
		"personal54": '받기',
		"personal55": '이메일 형식 오류',
		"personal56": '변경 완료!',
		"personal57": '비밀번호를 6~16자로 설정하세요',
		"personal58": '입력하신 두 비밀번호가 일치하지 않습니다',
		"personal59": '변경 완료!',
		"personal60": '로그아웃 완료!',
		"share_url": "링크 공유",
		"share_url_7_day": "공유 링크는 7일 동안 유효합니다. 만료되기 전에는 링크를 받은 모든 사람이 액세스할 수 있습니다.",
		"share_audio": "오디오 녹음",
		"share_trans_text": "녹음",
		"share_summny_text": "요약",
		"share_map": "마인드맵",
		"share_url_pw": "액세스 암호화",
		"share_random_pw": "비밀번호는 무작위로 생성됨",
		"share_url_copy": "링크 복사",
		"share_link_pw": "액세스 비밀번호",
		"share_copy_success": "복사 완료!",
		"share_speaker": "발언자",
		"share_no_update_speaker": "발언자를 편집할 수 없습니다. 비어 있음",
		"share_no_trans":"텍스트 변환 없음",
		"share_no_summny":"요약 없음",
		"share_no_map":"지도 콘텐츠 없음",
		"share_trans_text_1": "텍스트 변환",
		"share_summny_text_1": "요약",
		"share_map_1": "지도",
		"share_save": "저장 성공",
		"share_no_map":"지도 이미지가 생성되지 않았습니다",
		"share_update_text": "텍스트 변환 내용 수정",
		"share_update_text2": "요약 텍스트 편집",
		"showLoading": "로딩 중...",
	}
}